import styled from 'styled-components';
import { Toolbar } from 'devextreme-react/html-editor';

const Wrapper = styled.div`
    user-select: auto;
    border-bottom: 1px solid #f4f4f8;
    transition: border-color 0.3s ease;

    .htmlEditor {
        min-height: min(15vh, 150px);
        max-height: max(35vh, 500px);
    }
`;

const StyledToolbar = styled(Toolbar)`
    .dx-scrollable-container {
        height: unset !important;
    }

    .dx-scrollable-scroll-content {
        height: unset !important;
    }

    .dx-toolbar-menu-section {
        overflow: auto;
    }   
`;

const styledComponents = { Wrapper, StyledToolbar };

export default styledComponents;
